import { render } from "./PlanActivity.vue?vue&type=template&id=22677838&scoped=true"
import script from "./PlanActivity.vue?vue&type=script&lang=js"
export * from "./PlanActivity.vue?vue&type=script&lang=js"

import "./PlanActivity.vue?vue&type=style&index=0&id=22677838&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22677838"]])

export default __exports__